import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';

import { API_ENDPOINTS } from '../../shared/configuration/api-endpoints';
import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { CONFIGURATION } from '../../shared/configuration/configuration';

import { FileService } from '../../shared/services/file.service';
import { StorageService } from '../../shared/services/storage.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { ErrorService } from '../../shared/services/error.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';

@Injectable()
export class NceService {

    vNCEID = {
        nce_record_id: '',
        nce_request_id: ''
    };

    vNCEData = {
        nce_record_id: '',
        nce_request_id: '',
        onepay_reference_id: ''
    }

    vFillInParticulars = {
        plant_record_id: '',
        plant_request_id: '',
        nce_record_id: '',
        nce_request_id: '',
        nce_reference_id: '',
        prev_request_id: '',
        supervisor_name: '',
        supervisor_nric: '',
        supervisor_tel: '',
        supervisor_mobile: '',
        contract_principal: '',
        contract_officer: '',
        contract_tel: '',
        contract_mobile: '',
        contract_start: '',
        contract_end: '',
        contract_no: '',
        contract_company_name: '',
        contract_contact_number: '',
        contract_work_order: '',
        contract_contact_person: '',
        tcdw_name: '',
        tcdw_nric: '',
        tcdw_tel: '',
        tcdw_mobile: '',
        tcdw_license: '',
        tcdw_expiry_date: '',
        contractor_first_name: '',
        contractor_last_name: '',
        contractor_company_reg_no: '',
        contractor_telephone_no: '',
        contractor_company_name: '',
        contractor_company_address: '',
        contractor_contact_person: '',
        contractor_mobile_no: '',
        contractor_email: '',
        contractor_designation: '',
        contractor_postal_code: '',
        supervisor_company_name: '',
    }

    vEarthworkDetails = {
        location_earthwork: '',
        duration_from_date: '',
        duration_to_date: '',
        nature_proposed_earthwork: '',
        pipe_affected: '',
        distance_work_area: '',
        depth_earthwork: '',
        actual_start_date: '',
        estimate_end_date: '',
        work_under_s29: -1,
        already_start: -1,
        remark_1: false,
        remark_2: false,
        remark_3: false,
        remark_4: false,
        remark_5: false,
        remark_5_value: '',
        remarks: [],
        manholes_number: []
    }

    vDeclaration = {
        declare_name: '',
        declare_job_title: '',
        declare_phone_number: '',
        term_conditions: false
    }

    vPaymentData = {
        paymentMethod: '',
        payment_credential: true,
        price: '0'
    }

    vDetailNCE = {
        nce_record_id: '',
        nce_request_id: '',
        nce_reference_id: '',
        prev_request_id:'',
        plant_record_id: '',
        plant_request_id: '',
        supervisor_name: '',
        supervisor_nric: '',
        supervisor_tel: '',
        supervisor_mobile: '',
        contract_principal: '',
        contract_officer: '',
        contract_tel: '',
        contract_mobile: '',
        contract_start: '',
        contract_end: '',
        contract_no: '',
        contract_work_order: '',
        contract_contact_person: '',
        contract_contact_number: '',
        contract_company_name: '',
        tcdw_name: '',
        tcdw_nric: '',
        tcdw_tel: '',
        tcdw_mobile: '',
        tcdw_license: '',
        tcdw_expiry_date: '',
        contractor_company_address: '',
        contractor_company_name: '',
        contractor_company_reg_no: '',
        contractor_first_name: '',
        contractor_last_name: '',
        contractor_telephone_no: '',
        contractor_designation: '',
        contractor_email: '',
        contractor_mobile_no: '',
        contractor_contact_person: '',
        contractor_postal_code: '',
        supervisor_company_name: '',
        status: '',
        status_description:'',
        location_earthwork: '',
        duration_from_date: '',
        duration_to_date: '',
        pipe_affected: '',
        distance_work_area: '',
        nature_proposed_earthwork: '',
        depth_earthwork: '',
        actual_start_date: '',
        estimate_end_date: '',
        work_under_s29: -1,
        already_start: -1,
        earthwork_remark: [],
        manholes_number: [],
        attachment: {
            sketch: '',
            schedule: '',
            support: '',
            briefing: [],
            appointment: [],
            waiting_for_diversion: [],
            rejected: [],
            approval: [],
            plantmap: [],
            newplantmap: [],
            cancellation: [],
            finalApprovalApplication: [],
            finalApprovalApplicationForm: [],
            appointmentConfirmation: []
        },
        declare_name: '',
        declare_job_title: '',
        declare_phone_number: '',
        term_conditions: -1,
        appointment_date: '',
        appointment_time: '',
        appointment_description: '',
        first_name: '',
        last_name: '',
        company_name: '',
        phone_no: '',
        address_line_1: '',
        company_reg_no: '',
        apply_for_final_approval_contractor_name : '',
        apply_for_final_approval_bottom_contractor_designation : '',
        apply_for_final_approval_details : '',
        apply_for_final_approval_dates_1_completed : '',
        apply_for_final_approval_dates_1_date : '',
        apply_for_final_approval_dates_2_completed : '',
        apply_for_final_approval_dates_2_date : '',
        apply_for_final_approval_dates_3_completed : '',
        apply_for_final_approval_dates_3_date : '',
        apply_for_final_approval_dates_4_completed : '',
        apply_for_final_approval_dates_4_date : '',
        apply_for_final_approval_dates_5_completed : '',
        apply_for_final_approval_dates_5_date : '',
        apply_for_final_approval_dates_6_completed : '',
        apply_for_final_approval_dates_6_date : '',
        apply_for_final_approval_dates_7_completed : '',
        apply_for_final_approval_dates_7_date : '',
        last_status_change_date: '',
        create_date: '',
        appointmentHistory: [],
        rejection_remarks: [],
    }

    vAppointmentAvaibility = {
        updated_date: '',
        days: -1,
        holiday: [],
        buffer: -1,
    }

    vListTime: Array<{
        description: '',
        status: '',
        availability: false
    }> = [];
    
    vPlantMapExtensionID = '';

    vLoadingStatus: boolean;

    vIsPaymentPending: boolean = false;

    constructor(
        private _http: Http,
        private _pageNavigationService: PageNavigationService,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _fileService: FileService
    ) {
        this.vLoadingStatus = false;
        this.resetNCEData();
        this.resetFillInParticulars();
        this.resetEarthworkDetails();
        this.resetUploadDocumentData();
        this.resetDeclaration();
        this.resetNCEID();
    }

    isLoading(){
        return this.vLoadingStatus;
    }

    getFillInParticulars(){
        return this.vFillInParticulars;
    }

    getEarthworkDetails(){
        return this.vEarthworkDetails;
    }

    getDeclaration(){
        return this.vDeclaration;
    }

    getPaymentData(){
        return this.vPaymentData;
    }

    getRecordID(){
        return this.vNCEData.nce_record_id;
    }

    getRequestID(){
        return this.vNCEData.nce_request_id;
    }

    getDetailNCE(){
        return this.vDetailNCE;
    }

    getAppointmentAvaibility(){
        return this.vAppointmentAvaibility;
    }

    getListTime(){
        return this.vListTime;
    }

    getNCEID(){
        return this.vNCEID;
    }

    getIsPaymentPending() {
        return this.vIsPaymentPending;
    }

    setIsPaymentPending(pIsPaymentPending: boolean) {
        this.vIsPaymentPending = pIsPaymentPending;
    }

    resetNCEID(){
        let data = this._storageService.getSessionItem('NCEID');
        if(data !== null) {
            this.vNCEID = JSON.parse(data);
        }else {
            this.vNCEID = {
                nce_record_id: '',
                nce_request_id: ''
            };
        }
    }

    resetNCEData(){
        let data = this._storageService.getSessionItem('nceData');
        if(data !== null) {
            this.vNCEData = JSON.parse(data);
        }else {
            this.vNCEData = {
                nce_record_id: '',
                nce_request_id: '',
                onepay_reference_id: '' 
            };
        }
    }

    resetFillInParticulars(){
        let data = this._storageService.getSessionItem('nceParticulars');
        if(data !== null) {
            this.vFillInParticulars = JSON.parse(data);
        } else {
            this.vFillInParticulars = {
                plant_record_id: '',
                plant_request_id: '',
                nce_record_id: '',
                nce_request_id: '',
                nce_reference_id: '',
                prev_request_id: '',
                supervisor_name: '',
                supervisor_nric: '',
                supervisor_tel: '',
                supervisor_mobile: '',
                contract_principal: '',
                contract_officer: '',
                contract_tel: '',
                contract_mobile: '',
                contract_start: '',
                contract_end: '',
                contract_no: '',
                contract_work_order: '',
                contract_contact_person: '',
                contract_company_name: '',
                contract_contact_number: '',
                tcdw_name: '',
                tcdw_nric: '',
                tcdw_tel: '',
                tcdw_mobile: '',
                tcdw_license: '',
                tcdw_expiry_date: '',
                contractor_first_name: '',
                contractor_last_name: '',
                contractor_company_reg_no: '',
                contractor_telephone_no: '',
                contractor_company_name: '',
                contractor_company_address: '',
                contractor_contact_person: '',
                contractor_mobile_no: '',
                contractor_email: '',
                contractor_designation: '',
                contractor_postal_code: '',
                supervisor_company_name: '',

            };
        }
    }

    resetEarthworkDetails(){
        let data = this._storageService.getSessionItem('nceEarthwork');
        if(data !== null) {
            this.vEarthworkDetails = JSON.parse(data);
        } else {
            this.vEarthworkDetails = {
                location_earthwork: '',
                duration_from_date: '',
                duration_to_date: '',
                nature_proposed_earthwork: '',
                pipe_affected: '',
                distance_work_area: '',
                depth_earthwork: '',
                actual_start_date: '',
                estimate_end_date: '',
                work_under_s29: -1,
                already_start: -1,
                remark_1: false,
                remark_2: false,
                remark_3: false,
                remark_4: false,
                remark_5: false,
                remark_5_value: '',
                remarks: [],
                manholes_number: []
            };
        }
    }

    resetUploadDocumentData(){
        var tempFiles = this._storageService.getSessionItem('nceFiles');
        var tempMultipleFiles = this._storageService.getSessionItem('nceMultipleFiles');
        var tempNewMultipleFiles = this._storageService.getSessionItem('nceNewMultipleFiles')
        var vFiles;
        if(tempFiles === null || tempFiles === undefined){
            vFiles = [];
        } else {
            try{
                vFiles = JSON.parse(tempFiles);
            }catch(e){
                vFiles = [];
            }
        }
        this._fileService.vFiles = vFiles;

        var vMultipleFiles;
        if(tempMultipleFiles === null || tempMultipleFiles === undefined){
            vMultipleFiles = [];
        }else{
            try{
                vMultipleFiles = JSON.parse(tempMultipleFiles)
            }catch(e){
                vMultipleFiles = [];
            }
        }
        this._fileService.vMultipleFiles = vMultipleFiles;

        var vNewMultipleFiles;
        if(tempNewMultipleFiles === null || tempNewMultipleFiles === undefined){
            vNewMultipleFiles = [];
        }else{
            try{
                vNewMultipleFiles = JSON.parse(tempNewMultipleFiles)
            }catch(e){
                vNewMultipleFiles = [];
            }
        }
        this._fileService.vNewMultipleFiles = vNewMultipleFiles;
    }

    resetDeclaration(){
        let data = this._storageService.getSessionItem('nceDeclaration');
        if(data !== null) {
            this.vDeclaration = JSON.parse(data);
        }else {
            this.vDeclaration = {
                declare_name: '',
                declare_job_title: '',
                declare_phone_number: '',
                term_conditions: false
            };
        }
    }

    resetPaymentData(){
        this.vPaymentData = {
            paymentMethod: '',
            payment_credential: true,
            price: '0'
        }
    }

    updateStatus(pNceRecordID, pStatus){
        let xData = {
            nce_record_id: pNceRecordID,
            status: pStatus
        }
        var promise = this._http.post(API_ENDPOINTS.NCE.UPDATE_STATUS, xData);
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    insertApplicationForFinalApproval(nce_record_id, application_data) {
        let xData = {
            nce_record_id: nce_record_id,
            applcation_data: application_data
        }
        var promise = this._http.post(API_ENDPOINTS.NCE.APPLICATION_FOR_FINAL_APPROVAL, xData);
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    editNce(pNceDetail){
        let xData = pNceDetail;
        var promise = this._http.post(API_ENDPOINTS.NCE.EDIT_NCE, xData);
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    editPlantmap(pPlantmapDetail){
        //alert("payment_verified-->"+pPlantmapDetail.payment_verified);
        //alert("map_collected-->"+pPlantmapDetail.map_collected);
        let preview_feedback;
        let ppayment_verified;
        let pmap_collected;
        let pnewStatus;
        //alert(pPlantmapDetail.status );
        //if(pPlantmapDetail.status === 'PM_98'){
            if(pPlantmapDetail.review_feedback ){
                //alert('if' );
                pnewStatus =STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_PENDING
                preview_feedback= 1;
            } else {
                pnewStatus = STATIC_VALUE.ALL_PLANT_STATUS.REQUEST_REJECTED
                preview_feedback=0
            } 
        /*} else{
            if(pPlantmapDetail.review_feedback){
                preview_feedback= 1;
            } else {
                preview_feedback= 0;
            }
        }*/
        if(pPlantmapDetail.payment_verified){
            ppayment_verified =1
            pnewStatus =  STATIC_VALUE.ALL_PLANT_STATUS.PENDING_MAP_COLLECTION
        } else {ppayment_verified=0} 
        
        if(pPlantmapDetail.map_collected){
            pmap_collected =1
            pnewStatus = STATIC_VALUE.ALL_PLANT_STATUS.MAP_DELIVERED
        }else {pmap_collected=0}

        let xData = {
            plant_record_id : pPlantmapDetail.plant_record_id,
            project_title: pPlantmapDetail.project_title,
            location: pPlantmapDetail.location,
            main_contractor: pPlantmapDetail.main_contractor,
            restricted: pPlantmapDetail.restricted_area,
            newStatus:pnewStatus,
            review_feedback: preview_feedback,
            payment_verified: ppayment_verified,
            map_collected: pmap_collected
        }

        var promise = this._http.post(API_ENDPOINTS.PLANT_MAP.EDIT_PLANTMAP, xData);
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            response => {
                this.vLoadingStatus = false;
                resolve();
            },
            error  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    resetAllNCEData(){
        this._storageService.removeSessionItem('extensionNCE');
        this._storageService.removeSessionItem('nceData');
        this._storageService.removeSessionItem('nceParticulars');
        this._storageService.removeSessionItem('nceEarthwork');
        this._storageService.removeSessionItem('nceFiles');
        this._storageService.removeSessionItem('nceMultipleFiles');
        this._storageService.removeSessionItem('nceNewMultipleFiles');
        this._storageService.removeSessionItem('nceDeclaration');
        this.resetNCEData();
        this.resetFillInParticulars();
        this.resetEarthworkDetails();
        this.resetUploadDocumentData();
        this.resetDeclaration();
        this.resetPaymentData();
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    isDisableSaveFillInParticular(){
        if(this._storageService.getSessionItem('extensionNCE') === '0') {
            if(this.vFillInParticulars.plant_request_id === undefined || this.vFillInParticulars.plant_request_id === ''){
                return true;
            } else if(this.vFillInParticulars.plant_record_id === undefined || this.vFillInParticulars.plant_record_id === ''){
                return true;
            }else if(this.vFillInParticulars.supervisor_name === undefined || this.vFillInParticulars.supervisor_name === ''){
                return true;
            } else if(this.vFillInParticulars.supervisor_nric === undefined || this.vFillInParticulars.supervisor_nric === ''){
                return true;
            } else if(this.vFillInParticulars.supervisor_mobile === undefined || this.vFillInParticulars.supervisor_mobile === ''){
                return true;
            } else if(this.vFillInParticulars.contract_principal === undefined || this.vFillInParticulars.contract_principal === ''){
                return true; 
            } else if(this.vFillInParticulars.contract_officer === undefined || this.vFillInParticulars.contract_officer === ''){
                return true;
            } else if(this.vFillInParticulars.contract_mobile === undefined || this.vFillInParticulars.contract_mobile === ''){
                return true;
            } else if(this.vFillInParticulars.contract_start === undefined || this.vFillInParticulars.contract_start === ''){
                return true;
            } else if(this.vFillInParticulars.contract_company_name === undefined || this.vFillInParticulars.contract_company_name === ''){
                return true;
            } else if(this.vFillInParticulars.contract_contact_number === undefined || this.vFillInParticulars.contract_contact_number === ''){
                return true;
            } else if(this.vFillInParticulars.contract_contact_person === undefined || this.vFillInParticulars.contract_contact_person === ''){
                return true;
            } else if(this.vFillInParticulars.contract_end === undefined || this.vFillInParticulars.contract_end === ''){
                return true;
            } else if(this.vFillInParticulars.tcdw_name === undefined || this.vFillInParticulars.tcdw_name === ''){
                return true;
            } else if(this.vFillInParticulars.tcdw_nric === undefined || this.vFillInParticulars.tcdw_nric === ''){
                return true;
            } else if(this.vFillInParticulars.tcdw_mobile === undefined || this.vFillInParticulars.tcdw_mobile === ''){
                return true;
            } else if(this.vFillInParticulars.tcdw_license === undefined || this.vFillInParticulars.tcdw_license === ''){
                return true;
            // 1st March CR
            // } else if(this.vFillInParticulars.tcdw_expiry_date === undefined || this.vFillInParticulars.tcdw_expiry_date === ''){
            //     return true;
            } 
            //15 March CR
            // else if(this.vFillInParticulars.contractor_first_name === undefined || this.vFillInParticulars.contractor_first_name === ''){
            //     return true;
            // } else if(this.vFillInParticulars.contractor_last_name === undefined || this.vFillInParticulars.contractor_last_name === ''){
            //     return true;
            // } 
            else if(this.vFillInParticulars.contractor_company_reg_no === undefined || this.vFillInParticulars.contractor_company_reg_no === ''){
                return true;
            } 
            else if(this.vFillInParticulars.contractor_contact_person === undefined || this.vFillInParticulars.contractor_contact_person === ''){
                return true;
            }
            else if(this.vFillInParticulars.contractor_telephone_no === undefined || this.vFillInParticulars.contractor_telephone_no === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_company_name === undefined || this.vFillInParticulars.contractor_company_name === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_company_address === undefined || this.vFillInParticulars.contractor_company_address === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_mobile_no === undefined || this.vFillInParticulars.contractor_mobile_no === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_email === undefined || this.vFillInParticulars.contractor_email === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_designation === undefined || this.vFillInParticulars.contractor_designation === ''){
                return true;
            } else if(this.vFillInParticulars.contractor_postal_code === undefined || this.vFillInParticulars.contractor_postal_code === ''){
                return true;
            } else if(this.vFillInParticulars.tcdw_tel === undefined || this.vFillInParticulars.tcdw_tel === ''){
                return true;
            }
            return false;
        } else {
            if(this.vFillInParticulars.nce_request_id === undefined || this.vFillInParticulars.nce_request_id === '' || this.vFillInParticulars.nce_record_id === ''){
                return true;
            } else if(this.vFillInParticulars.contract_end === undefined || this.vFillInParticulars.contract_end === ''){
                return true;
            }
            return false;
        }
    }

    isDisableSaveEarthworkDetails(){
        if(this.vEarthworkDetails.location_earthwork === undefined || this.vEarthworkDetails.location_earthwork === ''){
            return true;
        } else if(this.vEarthworkDetails.duration_from_date === undefined || this.vEarthworkDetails.duration_from_date === ''){
            return true;
        } else if(this.vEarthworkDetails.duration_to_date === undefined || this.vEarthworkDetails.duration_to_date === ''){
            return true;
        } else if(this.vEarthworkDetails.pipe_affected === undefined || this.vEarthworkDetails.pipe_affected === ''){
            return true; 
        } else if(this.vEarthworkDetails.distance_work_area === undefined || this.vEarthworkDetails.distance_work_area === ''){
            return true;
        } 
        // else if(this.vEarthworkDetails.nature_proposed_earthwork === undefined || this.vEarthworkDetails.nature_proposed_earthwork === ''){
        //     return true;
        // } 
        else if(this.vEarthworkDetails.depth_earthwork === undefined || this.vEarthworkDetails.depth_earthwork === ''){
            return true;
        } else if(this.vEarthworkDetails.actual_start_date === undefined || this.vEarthworkDetails.actual_start_date === ''){
            return true;
        } else if(this.vEarthworkDetails.estimate_end_date === undefined || this.vEarthworkDetails.estimate_end_date === ''){
            return true;
        } else if(this.vEarthworkDetails.work_under_s29 === undefined || this.vEarthworkDetails.work_under_s29 === -1){
            return true;
        } else if(this.vEarthworkDetails.already_start === undefined || this.vEarthworkDetails.already_start === -1){
            return true;
        } else if(!this.vEarthworkDetails.remark_1 && !this.vEarthworkDetails.remark_2 && !this.vEarthworkDetails.remark_3
            && !this.vEarthworkDetails.remark_4 && !this.vEarthworkDetails.remark_5){
            return true;
        } else if(this.vEarthworkDetails.remark_5 && this.vEarthworkDetails.remark_5_value === '') {
            return true;
        } else if(this.vEarthworkDetails.manholes_number && this.vEarthworkDetails.manholes_number.length < 1) {
            return true;
        }
        return false;
    }

    isDisableSaveUpload(){
        if(this._fileService.vFiles[0] === undefined || this._fileService.vFiles[0] === ''){
            return true;
        } else if(this._fileService.vFiles[1] === undefined || this._fileService.vFiles[1] === ''){
            return true;
        } else if(this._fileService.vMultipleFiles[0] === undefined || this._fileService.vMultipleFiles[0] === ''){
            return true;
        } else if(this._storageService.getSessionItem('extensionNCE') === '1' && 
            (this._fileService.vNewMultipleFiles[0] === undefined || this._fileService.vNewMultipleFiles[0] === '')){
            return true;
        }
        return false;
    }

    isDisableSubmitDeclaration(){
        if(this.vDeclaration.declare_name === undefined || this.vDeclaration.declare_name === ''){
            return true;
        } else if(this.vDeclaration.declare_job_title === undefined || this.vDeclaration.declare_job_title === ''){
            return true;
        } else if(this.vDeclaration.term_conditions === undefined || this.vDeclaration.term_conditions === false){
            return true;
        } else if(this.vDeclaration.declare_phone_number === undefined || this.vDeclaration.declare_phone_number === ''){
            return true;
        }
        return false;
    }

    isDisablePayment(){
        if(this.vPaymentData.paymentMethod === undefined || this.vPaymentData.paymentMethod === ''){
            return true;
        }
        return false;
    }

    validateFillInParticular(){
        if(!/^\+?\d+$/.test(this.vFillInParticulars.supervisor_tel) && this.vFillInParticulars.supervisor_tel !== '' && this.vFillInParticulars.supervisor_tel !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('supervisorTel', 'Tel No provided is not valid');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.supervisor_mobile) && this.vFillInParticulars.supervisor_mobile !== '' && this.vFillInParticulars.supervisor_mobile !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('supervisorMobile', 'Mobile No provided is not valid');
        } else if(this.vFillInParticulars.supervisor_mobile.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('supervisorMobile', 'Mobile No length must be more than 8');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.contract_tel) && this.vFillInParticulars.contract_tel !== '' && this.vFillInParticulars.contract_tel !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractTel', 'Tel No provided is not valid');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.contract_mobile) && this.vFillInParticulars.contract_mobile !== '' && this.vFillInParticulars.contract_mobile !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractMobile', 'Mobile No provided is not valid');
        } else if(this.vFillInParticulars.contract_mobile.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractMobile', 'Mobile No length must be more than 8');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.tcdw_tel) && this.vFillInParticulars.tcdw_tel !== '' && this.vFillInParticulars.tcdw_tel !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('tcdwTel', 'Tel No provided is not valid');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.tcdw_mobile) && this.vFillInParticulars.tcdw_mobile !== '' && this.vFillInParticulars.tcdw_mobile !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('tcdwMobile', 'Mobile No provided is not valid');
        } else if(this.vFillInParticulars.tcdw_mobile.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('tcdwMobile', 'Mobile No length must be more than 8');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.contractor_telephone_no) && this.vFillInParticulars.contractor_telephone_no !== '' && this.vFillInParticulars.contractor_telephone_no !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Phone No provided is not valid');
        } else if(this.vFillInParticulars.contractor_telephone_no.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Phone No length must be more than 8');
        }
        if(!/^\+?\d+$/.test(this.vFillInParticulars.contractor_mobile_no) && this.vFillInParticulars.contractor_mobile_no !== '' && this.vFillInParticulars.contractor_mobile_no !== null){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Phone No provided is not valid');
        } else if(this.vFillInParticulars.contractor_mobile_no.length < 8){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('contractorPhone', 'Phone No length must be more than 8');
        }
        let extensionNCE = this._storageService.getSessionItem('extensionNCE');
        if(extensionNCE === '1'){
        } else if(extensionNCE === '0') {
            if(this.vFillInParticulars.supervisor_nric.length != 4){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('spvNric', 'Supervisor NRIC should be only last 4 digits');
            }else if (!/^\d{3}[A-Z]$/.test(this.vFillInParticulars.supervisor_nric.toUpperCase())){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('spvNric', 'Supervisor NRIC must be contain 3 number and 1 alphabets');
            }
            if(this.vFillInParticulars.tcdw_nric.length != 4){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('tcdwNric', 'TCDW NRIC should be only last 4 digits');
            }else if (!/^\d{3}[A-Z]$/.test(this.vFillInParticulars.tcdw_nric.toUpperCase())){
                this._errorService.setErrorFlag(true);
                this._errorService.setErrorStatusAndMessage('tcdwNric', 'TCDW NRIC must be contain 3 number and 1 alphabets');
            }
        }
    }

    validateEarthworkDetails(){
        // if(!/^[0-9]+$/.test(this.vEarthworkDetails.pipe_affected)){
        //     this._errorService.setErrorFlag(true);
        //     this._errorService.setErrorStatusAndMessage('pipeAffected', 'Pipes Affected must be number');
        // }
        if(!Number(this.vEarthworkDetails.distance_work_area) || Number(this.vEarthworkDetails.distance_work_area) < 0){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('distanceArea', 'Distance Area Affected must be number');
        }
        if(!Number(this.vEarthworkDetails.depth_earthwork) || Number(this.vEarthworkDetails.depth_earthwork) < 0){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('depthEarthwork', 'Depth Earthwork must be number');
        }
    }

    checkPlantRequestID(pRequestID, pPIN){
        this.resetError();
        this.vFillInParticulars.plant_record_id = '';
        if(pRequestID === ''){
            return;
        }
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.PLANT_MAP.CHECK_STATUS + '?plant_request_id=' + pRequestID + '&plant_pin=' + pPIN || '').subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.resetAllNCEData();

                this._storageService.setSessionItem('extensionNCE', '0');
                this.vFillInParticulars.plant_request_id = pRequestID;
                this.vFillInParticulars.plant_record_id = vResponseData.data.plant_record_id;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 53501){
                    this._errorService.setErrorStatusAndMessage('plantRequestID', 'Plant Map does not exist');
                } else if (vErrorData.code === 53502){
                    this._errorService.setErrorStatusAndMessage('plantRequestID', 'Plant Map is not done yet');
                } else if (vErrorData.code === 53503){
                    this._errorService.setErrorStatusAndMessage('plantMapPin', 'Invalid Plant Map PIN');
                } else if (vErrorData.code === 53504){
                    this._errorService.setErrorStatusAndMessage('plantRequestID', 'This plant map has already been used for another NCE application');
                } else if (vErrorData.code === 53506){
                    this._errorService.setErrorStatusAndMessage('plantRequestID', 'Plant Map has already expired.');
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    checkNCERequestID(pNCERequestID, pPlantRequestID, pPIN){
        this.resetError();
        this.vFillInParticulars.nce_record_id = '';
        if(pNCERequestID === ''){
            return;
        }
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.NCE.CHECK_STATUS + '?nce_request_id=' + pNCERequestID + '&plant_request_id=' + pPlantRequestID + '&plant_pin=' + pPIN || '').subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this.resetAllNCEData();
                this.vPlantMapExtensionID = pPlantRequestID;
                this._storageService.setSessionItem('extensionNCE', '1');
                this.loadDetailNCE(vResponseData.data.nce_record_id).then(
                    (resolve) => {
                        this._storageService.setSessionItem('extensionNCE', '1');
                        this.vFillInParticulars.nce_request_id = pNCERequestID;
                        this.vFillInParticulars.nce_record_id = vResponseData.data.nce_record_id;
                        let data = resolve['data'];
                        this.vFillInParticulars.nce_reference_id = data.nceapplications.nce_reference_id;
                        this.vFillInParticulars.prev_request_id = data.nceapplications.prev_request_id;
                        this.mapDataToNCE(data);
                    },
                    (reject) => {

                    }
                );
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 53501){
                    this._errorService.setErrorStatusAndMessage('plantRequestIDExt', 'Plant Map does not exist');
                } else if (vErrorData.code === 53502){
                    this._errorService.setErrorStatusAndMessage('plantRequestIDExt', 'Plant Map is not done yet');
                } else if (vErrorData.code === 53503){
                    this._errorService.setErrorStatusAndMessage('plantMapPin', 'Invalid Plant Map PIN');
                } else if (vErrorData.code === 53504){
                    this._errorService.setErrorStatusAndMessage('plantRequestIDExt', 'This plant map has already been used for another NCE application');
                } else if (vErrorData.code === 53506){
                    this._errorService.setErrorStatusAndMessage('plantRequestIDExt', 'Plant Map has already expired.');
                } else if(vErrorData.code === 56503){
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application is invalid');
                } else if (vErrorData.code === 56504){
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application is not approved yet');
                } else if(vErrorData.code === 56510) {
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application is in pending payment, please continue your NCE.');
                } else if (vErrorData.code === 56506){
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application extend limit has been reached');
                } else if(vErrorData.code === 56507) {
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application extend period has ended');
                } else if(vErrorData.code === 56509) {
                    this._errorService.setErrorStatusAndMessage('NCERequestID', 'NCE Application is not in period to extend');
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    mapDataToNCE(data){
        this.vFillInParticulars.plant_request_id = data.nceapplications.plant_request_id;
        this.vFillInParticulars.supervisor_name = data.nceapplications.supervisor_name;
        this.vFillInParticulars.supervisor_nric = data.nceapplications.supervisor_nric;
        this.vFillInParticulars.supervisor_tel = data.nceapplications.supervisor_tel;
        this.vFillInParticulars.supervisor_mobile = data.nceapplications.supervisor_mobile;
        this.vFillInParticulars.supervisor_company_name = data.nceapplications.supervisor_company_name;
        this.vFillInParticulars.contract_principal = data.nceapplications.contract_principal;
        this.vFillInParticulars.contract_officer = data.nceapplications.contract_officer;
        this.vFillInParticulars.contract_tel = data.nceapplications.contract_tel;
        this.vFillInParticulars.contract_mobile = data.nceapplications.contract_mobile;
        this.vFillInParticulars.contract_start = data.nceapplications.contract_start;
        this.vFillInParticulars.contract_company_name = data.nceapplications.contract_company_name;
        this.vFillInParticulars.contract_contact_number = data.nceapplications.contract_contact_number;
        //this.vFillInParticulars.contract_end = data.nceapplications.contract_end;
        this.vFillInParticulars.contract_no = data.nceapplications.contract_no;
        this.vFillInParticulars.contract_work_order = data.nceapplications.contract_work_order;
        this.vFillInParticulars.contract_contact_person = data.nceapplications.contract_contact_person;
        this.vFillInParticulars.tcdw_name = data.nceapplications.tcdw_name;
        this.vFillInParticulars.tcdw_nric = data.nceapplications.tcdw_nric;
        this.vFillInParticulars.tcdw_tel = data.nceapplications.tcdw_tel;
        this.vFillInParticulars.tcdw_mobile = data.nceapplications.tcdw_mobile;
        this.vFillInParticulars.tcdw_license = data.nceapplications.tcdw_license;
        this.vFillInParticulars.tcdw_expiry_date = data.nceapplications.tcdw_expiry_date;
        // Contractor's Details
        this.vFillInParticulars.contractor_company_address = data.nceapplications.contractor_company_address || '';
        this.vFillInParticulars.contractor_company_name = data.nceapplications.contractor_company_name || '';
        this.vFillInParticulars.contractor_company_reg_no = data.nceapplications.company_reg_no || '';
        this.vFillInParticulars.contractor_mobile_no = data.nceapplications.contractor_mobile_no || '',
        // this.vFillInParticulars.contractor_first_name = data.nceapplications.first_name || '';
        // this.vFillInParticulars.contractor_last_name = data.nceapplications.last_name || '';
        this.vFillInParticulars.contractor_contact_person = data.nceapplications.contractor_contact_person || '',
        this.vFillInParticulars.contractor_telephone_no = data.nceapplications.contractor_telephone_no || '';
        this.vFillInParticulars.contractor_postal_code = data.nceapplications.contractor_postal_code || '',
        this.vFillInParticulars.contractor_email = data.nceapplications.contractor_email || '',
        this.vFillInParticulars.contractor_designation = data.nceapplications.contractor_designation || '',
        //this._storageService.setSessionItem('nceParticulars', JSON.stringify(this.vFillInParticulars));

        this.vEarthworkDetails.location_earthwork = data.nceapplications.location_earthwork;
        this.vEarthworkDetails.pipe_affected = data.nceapplications.pipe_affected;
        this.vEarthworkDetails.distance_work_area = data.nceapplications.distance_work_area;
        this.vEarthworkDetails.nature_proposed_earthwork = data.nceapplications.nature_proposed_earthwork;
        this.vEarthworkDetails.depth_earthwork = data.nceapplications.depth_earthwork;
        this.vEarthworkDetails.work_under_s29 = data.nceapplications.work_under_s29;
        this.vEarthworkDetails.remarks = data.nceapplications.earthwork_remark;
        let totalRemark = this.vEarthworkDetails.remarks !== undefined ? this.vEarthworkDetails.remarks.length : 0;
        if(this.vEarthworkDetails.remarks.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[0])) {
            this.vEarthworkDetails.remark_1  = true;
            totalRemark--;
        } else {
            this.vEarthworkDetails.remark_1  = false;
        }
        if(this.vEarthworkDetails.remarks.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[1])) {
            this.vEarthworkDetails.remark_2  = true;
            totalRemark--;
        } else {
            this.vEarthworkDetails.remark_2  = false;
        }
        if(this.vEarthworkDetails.remarks.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[2])) {
            this.vEarthworkDetails.remark_3  = true;
            totalRemark--;
        } else {
            this.vEarthworkDetails.remark_3  = false;
        }
        if(this.vEarthworkDetails.remarks.some(x => x === STATIC_VALUE.NCE_EARTHWORK_REMARKS[3])) {
            this.vEarthworkDetails.remark_4  = true;
            totalRemark--;
        } else {
            this.vEarthworkDetails.remark_4  = false;
        }
        if(totalRemark > 0) {
            this.vEarthworkDetails.remark_5_value = this.vEarthworkDetails.remarks[this.vEarthworkDetails.remarks.length - 1];
            this.vEarthworkDetails.remark_5  = true;
        } else {
            this.vEarthworkDetails.remark_5_value = '';
            this.vEarthworkDetails.remark_5  = false;
        }
        this.vEarthworkDetails.manholes_number = data.nceapplications.manholes_number;
        this._storageService.setSessionItem('nceEarthwork', JSON.stringify(this.vEarthworkDetails));

        this._fileService.vFiles[0] = data.nceapplications.attachment.sketch;
        this._fileService.vFiles[1] = data.nceapplications.attachment.schedule;
        this._fileService.vFiles[2] = data.nceapplications.attachment.support;
        this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));

        this._fileService.vMultipleFiles = data.nceapplications.attachment.plantmap;
        this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));

        this._fileService.vNewMultipleFiles = data.nceapplications.attachment.newplantmap;
        this._storageService.setSessionItem('nceNewMultipleFiles', JSON.stringify(this._fileService.getNewMultipleFilesList()));
        
        this.vDeclaration.declare_name = data.nceapplications.declare_name;
        this.vDeclaration.declare_job_title = data.nceapplications.declare_job_title;
        this.vDeclaration.declare_phone_number = data.nceapplications.declare_phone_number;
        this.vDeclaration.term_conditions = data.nceapplications.term_conditions === 1 ? true : false;
        this._storageService.setSessionItem('nceDeclaration', JSON.stringify(this.vDeclaration));
    }

    loadReferenceID(pNCEID){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE.GET_REFERENCE_ID + '?nce_record_id=' + pNCEID);
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData:any = response;
                    console.log(vResponseData);
                    resolve(vResponseData);
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                }
            );
        });
        return p;
    }

    saveFillInParticulars(){
        this.resetError();
        this.validateFillInParticular();
        if(this._errorService.getErrorFlag()){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the profile update. Thank You.', '', false, false);
            return;
        }
        this._storageService.setSessionItem('nceParticulars',JSON.stringify(this.vFillInParticulars));
        let vLink = ['nce-application/earthwork-details'];
        this._pageNavigationService.navigate(vLink);
    }

    saveEarthworkDetails(){
        this.resetError();
        this.validateEarthworkDetails();
        if(this._errorService.getErrorFlag()){
            this._popupService.openGeneralConfirmationPopup('Notice', 'Some of the required information is invalid or missing. Please correct them before proceeding with the profile update. Thank You.', '', false, false);
            return;
        }

        let tempContractStart = new Date(this.vFillInParticulars.contract_start);
        let tempContractEnd = new Date(this.vFillInParticulars.contract_end);
        let tempExpiryDate = new Date();
        // let tempExpiryDate = new Date(this.vFillInParticulars.tcdw_expiry_date);
        let tempDurationFrom = new Date(this.vEarthworkDetails.duration_from_date);
        let tempDurationTo = new Date(this.vEarthworkDetails.duration_to_date);
        let tempActualStart = new Date(this.vEarthworkDetails.actual_start_date);
        let tempEstimateEnd = new Date(this.vEarthworkDetails.estimate_end_date);

        this.vEarthworkDetails.remarks = [];

        if(this.vEarthworkDetails.remark_1){
            this.vEarthworkDetails.remarks.push(STATIC_VALUE.NCE_EARTHWORK_REMARKS[0]);
        }
        if(this.vEarthworkDetails.remark_2){
            this.vEarthworkDetails.remarks.push(STATIC_VALUE.NCE_EARTHWORK_REMARKS[1]);
        }
        if(this.vEarthworkDetails.remark_3){
            this.vEarthworkDetails.remarks.push(STATIC_VALUE.NCE_EARTHWORK_REMARKS[2]);
        }
        if(this.vEarthworkDetails.remark_4){
            this.vEarthworkDetails.remarks.push(STATIC_VALUE.NCE_EARTHWORK_REMARKS[3]);
        }
        if(this.vEarthworkDetails.remark_5){
            this.vEarthworkDetails.remarks.push(this.vEarthworkDetails.remark_5_value);
        }
        let xData = {
            nce_record_id: !Number(this.vNCEData.nce_record_id) ? 0 : parseInt(this.vNCEData.nce_record_id) ,
            plant_record_id: this.vFillInParticulars.plant_record_id,
            supervisor_name: this.vFillInParticulars.supervisor_name,
            supervisor_nric: this.vFillInParticulars.supervisor_nric,
            supervisor_tel: this.vFillInParticulars.supervisor_tel,
            supervisor_mobile: this.vFillInParticulars.supervisor_mobile,
            contract_principal: this.vFillInParticulars.contract_principal,
            contract_officer: this.vFillInParticulars.contract_officer,
            contract_tel: this.vFillInParticulars.contract_tel,
            contract_mobile: this.vFillInParticulars.contract_mobile,
            contract_start: tempContractStart.getFullYear() + '' + ("0" + (tempContractStart.getMonth() + 1)).slice(-2) + '' + ("0" + tempContractStart.getDate()).slice(-2),
            contract_end: tempContractEnd.getFullYear() + '' + ("0" + (tempContractEnd.getMonth() + 1)).slice(-2) + '' + ("0" + tempContractEnd.getDate()).slice(-2),
            contract_no: this.vFillInParticulars.contract_no,
            contract_work_order: this.vFillInParticulars.contract_work_order,
            contract_contact_person: this.vFillInParticulars.contract_contact_person,
            contract_contact_number: this.vFillInParticulars.contract_contact_number,
            contract_company_name: this.vFillInParticulars.contract_company_name,
            tcdw_name: this.vFillInParticulars.tcdw_name,
            tcdw_nric: this.vFillInParticulars.tcdw_nric,
            tcdw_tel: this.vFillInParticulars.tcdw_tel,
            tcdw_mobile: this.vFillInParticulars.tcdw_mobile,
            tcdw_license: this.vFillInParticulars.tcdw_license,
            contractor_company_address: this.vFillInParticulars.contractor_company_address,
            contractor_company_name: this.vFillInParticulars.contractor_company_name,
            contractor_company_reg_no: this.vFillInParticulars.contractor_company_reg_no,
            // contractor_first_name: this.vFillInParticulars.contractor_first_name,
            // contractor_last_name: this.vFillInParticulars.contractor_last_name,
            contractor_telephone_no: this.vFillInParticulars.contractor_telephone_no,
            contractor_contact_person: this.vFillInParticulars.contractor_contact_person,
            contractor_mobile_no: this.vFillInParticulars.contractor_mobile_no,
            contractor_email: this.vFillInParticulars.contractor_email,
            contractor_designation: this.vFillInParticulars.contractor_designation,
            contractor_postal_code: this.vFillInParticulars.contractor_postal_code,
            supervisor_company_name: this.vFillInParticulars.supervisor_company_name,
            tcdw_expiry_date: tempExpiryDate.getFullYear() + '' + ("0" + (tempExpiryDate.getMonth() + 1)).slice(-2) + '' + ("0" + tempExpiryDate.getDate()).slice(-2),
            location_earthwork: this.vEarthworkDetails.location_earthwork,
            duration_from_date: tempDurationFrom.getFullYear() + '' + ("0" + (tempDurationFrom.getMonth() + 1)).slice(-2) + '' + ("0" + tempDurationFrom.getDate()).slice(-2),
            duration_to_date: tempDurationTo.getFullYear() + '' + ("0" + (tempDurationTo.getMonth() + 1)).slice(-2) + '' + ("0" + tempDurationTo.getDate()).slice(-2),
            pipe_affected: this.vEarthworkDetails.pipe_affected,
            distance_work_area: this.vEarthworkDetails.distance_work_area,
            nature_proposed_earthwork: this.vEarthworkDetails.nature_proposed_earthwork,
            depth_earthwork: this.vEarthworkDetails.depth_earthwork,
            actual_start_date: tempActualStart.getFullYear() + '' + ("0" + (tempActualStart.getMonth() + 1)).slice(-2) + '' + ("0" + tempActualStart.getDate()).slice(-2),
            estimate_end_date: tempEstimateEnd.getFullYear() + '' + ("0" + (tempEstimateEnd.getMonth() + 1)).slice(-2) + '' + ("0" + tempEstimateEnd.getDate()).slice(-2),
            work_under_s29: this.vEarthworkDetails.work_under_s29,
            already_start: this.vEarthworkDetails.already_start,
            earthwork_remark: this.vEarthworkDetails.remarks,
            manholes_number: this.vEarthworkDetails.manholes_number,
        }

        console.log(xData);

        this.vLoadingStatus = true;

        this._storageService.setSessionItem('nceEarthwork',JSON.stringify(this.vEarthworkDetails));

        this._http.post(API_ENDPOINTS.NCE.CREATE_TEMPORARY_NCE, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this.vNCEData.nce_record_id = vResponseData.data.nce_record_id.toString();
                this.vNCEData.nce_request_id = vResponseData.data.nce_request_id.toString();
                this._storageService.setSessionItem('nceData',JSON.stringify(this.vNCEData));
                
                this.vFillInParticulars.nce_reference_id = vResponseData.data.nce_record_id.toString();
                this.vFillInParticulars.prev_request_id = vResponseData.data.nce_request_id.toString();
                this._storageService.setSessionItem('nceParticulars',JSON.stringify(this.vFillInParticulars));
                
                let vLink = ['nce-application/upload-attachment'];
                this._pageNavigationService.navigate(vLink);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    saveEarthworkDetailsExt(){
        let tempContractEnd = new Date(this.vFillInParticulars.contract_end);
        let tempDurationFrom = new Date(this.vEarthworkDetails.duration_from_date);
        let tempDurationTo = new Date(this.vEarthworkDetails.duration_to_date);
        let tempActualStart = new Date(this.vEarthworkDetails.actual_start_date);
        let tempEstimateEnd = new Date(this.vEarthworkDetails.estimate_end_date);

        let xData = {
            plant_request_id: this.vPlantMapExtensionID,
            nce_record_id: !Number(this.vNCEData.nce_record_id) ? 0 : this.vNCEData.nce_record_id,
            nce_reference_id: this.vFillInParticulars.nce_record_id,
            contract_end: tempContractEnd.getFullYear() + '' + ("0" + (tempContractEnd.getMonth() + 1)).slice(-2) + '' + ("0" + tempContractEnd.getDate()).slice(-2),
            duration_from_date: tempDurationFrom.getFullYear() + '' + ("0" + (tempDurationFrom.getMonth() + 1)).slice(-2) + '' + ("0" + tempDurationFrom.getDate()).slice(-2),
            duration_to_date: tempDurationTo.getFullYear() + '' + ("0" + (tempDurationTo.getMonth() + 1)).slice(-2) + '' + ("0" + tempDurationTo.getDate()).slice(-2),
            actual_start_date: tempActualStart.getFullYear() + '' + ("0" + (tempActualStart.getMonth() + 1)).slice(-2) + '' + ("0" + tempActualStart.getDate()).slice(-2),
            estimate_end_date: tempEstimateEnd.getFullYear() + '' + ("0" + (tempEstimateEnd.getMonth() + 1)).slice(-2) + '' + ("0" + tempEstimateEnd.getDate()).slice(-2),
            already_start: this.vEarthworkDetails.already_start,
            trans_method: this.vPaymentData.paymentMethod,
            trans_amount: this.vPaymentData.price
        };

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.NCE.CREATE_TEMP_EXTENSION, xData).subscribe(
            (response) => {   
                let vResponseData:any = response;
                console.log(vResponseData);

                this.vNCEData.nce_record_id = vResponseData.data.nce_record_id.toString();
                this.vNCEData.nce_request_id = vResponseData.data.nce_request_id.toString();
                this._storageService.setSessionItem('nceData',JSON.stringify(this.vNCEData));
                
                this.vFillInParticulars.nce_reference_id = vResponseData.data.nce_reference_id.toString();
                this.vFillInParticulars.prev_request_id = vResponseData.data.prev_request_id.toString();

                this.loadDetailNCE(vResponseData.data.nce_record_id).then(
                    (resolve) => {
                        this._storageService.setSessionItem('extensionNCE', '1');
                        let data = resolve['data'];
                        this.mapDataToNCE(data);
                        this._storageService.setSessionItem('nceParticulars',JSON.stringify(this.vFillInParticulars));
                        this._storageService.setSessionItem('nceEarthwork',JSON.stringify(this.vEarthworkDetails));  

                        if(vResponseData.data.updated != '1') {                    
                            this._fileService.vFiles = [];       
                            this._fileService.vMultipleFiles = [];
                            this._fileService.vNewMultipleFiles = [];
                            this._storageService.removeSessionItem('nceFiles');
                            this._storageService.removeSessionItem('nceMultipleFiles');
                            this._storageService.removeSessionItem('nceNewMultipleFiles');
                            this.vLoadingStatus = false;
                        } else {
                            this._fileService.vFiles[0] = data.nceapplications.attachment.sketch;
                            this._fileService.vFiles[1] = data.nceapplications.attachment.schedule;
                            this._fileService.vFiles[2] = data.nceapplications.attachment.support;
                            this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
                    
                            this._fileService.vMultipleFiles = data.nceapplications.attachment.plantmap;
                            this._storageService.setSessionItem('nceMultipleFiles', JSON.stringify(this._fileService.getMultipleFilesList()));
                    
                            this._fileService.vNewMultipleFiles = data.nceapplications.attachment.newplantmap;
                            this._storageService.setSessionItem('nceNewMultipleFiles', JSON.stringify(this._fileService.getNewMultipleFilesList()));
                            this.vLoadingStatus = false;                    
                        }
                        let vLink = ['nce-application/upload-attachment'];
                        // let vLink = ['nce-application/preview'];
                        this._pageNavigationService.navigate(vLink);
                    },
                    (reject) => {
                        this.vLoadingStatus = false;
                    }
                );             
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                if(vErrorData.nce_record_id !== undefined && vErrorData.nce_request_id !== undefined){
                    this.vNCEData.nce_record_id = vErrorData.nce_record_id;
                    this.vNCEData.nce_request_id = vErrorData.nce_request_id;
                    this._storageService.setSessionItem('nceData', JSON.stringify(this.vNCEData));
                }
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    saveDeclaration(){
        this._storageService.setSessionItem('nceDeclaration',JSON.stringify(this.vDeclaration));
        let vLink = ['nce-application/preview'];
        this._pageNavigationService.navigate(vLink);
    }

    checkPaymentCredential(){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.ACCOUNT.PAYMENT_CREDENTIAL);

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData:any = response;
                    console.log(vResponseData);
                    this.vPaymentData.payment_credential = vResponseData.data.payment;
                    resolve();
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    let vErrorData = error;
                    this._errorService.setErrorFlag(true);
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                    reject();
                }
            );
        });
        return p;
    }

    loadNCEPrice(){
        this.vLoadingStatus = true;
        let extensionNCE = this._storageService.getSessionItem('extensionNCE');

        if(extensionNCE === '1'){
            var promise = this._http.get(API_ENDPOINTS.NCE.GET_NCE_EXT_PRICE);
        } else if(extensionNCE === '0') {
            var promise = this._http.get(API_ENDPOINTS.NCE.GET_NCE_PRICE);
        }

        let p = new Promise((resolve, reject) => {
            promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vPaymentData.price = vResponseData.data.price;
                resolve();
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    mapNCEID(){
        this.vNCEID.nce_record_id = this.vNCEData.nce_record_id;
        this.vNCEID.nce_request_id = this.vNCEData.nce_request_id;
        this._storageService.setSessionItem('NCEID', JSON.stringify(this.vNCEID));
    }

    submitPayment(){
        this.resetError();
        if(this._storageService.getSessionItem('extensionNCE') === '0') {
            this.submitPaymentNoExtension();
        } else {
            this.submitPaymentExtension();
        }
    }

    submitPaymentNoExtension(){
        let xData = {
            nce_record_id: this.vNCEData.nce_record_id,
            declare_name: this.vDeclaration.declare_name,
            declare_job_title: this.vDeclaration.declare_job_title,
            declare_phone_number: this.vDeclaration.declare_phone_number,
            term_conditions: 1,
            trans_method: this.vPaymentData.paymentMethod,
            trans_amount: this.vPaymentData.price
        }
        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.NCE.UPDATE_TEMPORARY_NCE, xData).subscribe(
            (response) => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vNCEData.nce_record_id = vResponseData.data.nce_record_id;
                this.vNCEData.nce_request_id = vResponseData.data.nce_request_id;
                this.vNCEData.onepay_reference_id = vResponseData.data.onepay_reference_id;
                this._storageService.setSessionItem('nceData', JSON.stringify(this.vNCEData));
                if(vResponseData.data.URL === undefined){
                    this.vLoadingStatus = false;
                    this.mapNCEID();
                    this._pageNavigationService.navigate(['nce-application/confirmation']);
                } else {
                    this.mapNCEID();
                    var url = vResponseData.data.URL;
                    if(url.indexOf(CONFIGURATION.payRedirectConfig[CONFIGURATION.modeEnv].URL) > -1){
                        window.location.href = url;
                    } else {
                        this.vLoadingStatus = false;
                        this._popupService.openGeneralConfirmationPopup('Error', 'Failed to process payment, please try again.', '', false, false);
                    }
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                if(vErrorData.nce_record_id !== undefined && vErrorData.nce_request_id !== undefined){
                    this.vNCEData.nce_record_id = vErrorData.nce_record_id;
                    this.vNCEData.nce_request_id = vErrorData.nce_request_id;
                    this._storageService.setSessionItem('nceData', JSON.stringify(this.vNCEData));
                }
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    submitPaymentExtension(){
        let xData = {
            plant_request_id: this.vPlantMapExtensionID || this.vFillInParticulars.plant_request_id,
            nce_record_id: !Number(this.vNCEData.nce_record_id) ? 0 : this.vNCEData.nce_record_id,
            nce_reference_id: this.vFillInParticulars.nce_record_id,
            trans_method: this.vPaymentData.paymentMethod,
            trans_amount: this.vPaymentData.price
        };

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.NCE.CREATE_EXTENSION, xData).subscribe(
            (response) => {
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vNCEData.nce_record_id = vResponseData.data.nce_record_id;
                this.vNCEData.nce_request_id = vResponseData.data.nce_request_id;
                this.vNCEData.onepay_reference_id = vResponseData.data.onepay_reference_id;
                this._storageService.setSessionItem('nceData', JSON.stringify(this.vNCEData));
                this.vLoadingStatus = true;
                if(vResponseData.data.URL === undefined){
                    this.vLoadingStatus = false;
                    this.mapNCEID();
                    let vLink = ['nce-application/preview'];
                    this._pageNavigationService.navigate(vLink);
                } else {
                    this.mapNCEID();
                    var url = vResponseData.data.URL;
                    if(url.indexOf(CONFIGURATION.payRedirectConfig[CONFIGURATION.modeEnv].URL) > -1){
                        window.location.href = url;
                    } else {
                        this.vLoadingStatus = false;
                        this._popupService.openGeneralConfirmationPopup('Error', 'Failed to process payment, please try again.', '', false, false);
                    }
                }
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                if(vErrorData.nce_record_id !== undefined && vErrorData.nce_request_id !== undefined){
                    this.vNCEData.nce_record_id = vErrorData.nce_record_id;
                    this.vNCEData.nce_request_id = vErrorData.nce_request_id;
                    this._storageService.setSessionItem('nceData', JSON.stringify(this.vNCEData));
                }
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    getPaymentAvailability(){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.ACCOUNT.PAYMENT_CREDENTIAL);

        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData = response;
                console.log(vResponseData);
                resolve(response);
            },
            (error)  => {
                console.log(error);
                this.vLoadingStatus = false;
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadTransaction(pFailureReason){
        let data = this._storageService.getSessionItem('nceData');
        this.vNCEData = JSON.parse(data);
        let xData = {
            nce_record_id: this.vNCEData.nce_record_id,
            onepay_reference_id: this.vNCEData.onepay_reference_id,
            failure_reason: pFailureReason === undefined || pFailureReason === null ? '' : pFailureReason
        }
        var promise;
        if(this._storageService.getSessionItem('extensionNCE') === '0') {
            promise = this._http.post(API_ENDPOINTS.NCE.LOAD_TRANSACTION, xData);
        } else {
            promise = this._http.post(API_ENDPOINTS.NCE.LOAD_TRANSACTION_EXTENSION, xData);
        }

        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                resolve(vResponseData);
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadDetailNCE(pNCEid){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE.PREVIEW + '?nce_record_id=' + pNCEid);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vNCEID = {
                    nce_record_id: pNCEid,
                    nce_request_id: vResponseData.data.nceapplications.nce_request_id
                };
                this._storageService.setSessionItem('NCEID', JSON.stringify(this.vNCEID));                
                this.vDetailNCE = vResponseData.data.nceapplications;                
                if(this.getDetailNCE().nce_request_id.slice(-2) === '-1'){
                    this._storageService.setSessionItem('extensionNCE', '0');
                } else {
                    this._storageService.setSessionItem('extensionNCE', '1');
                    this.vPlantMapExtensionID = this.vDetailNCE.plant_request_id;
                }
                resolve(vResponseData);
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadAdminDetailNCE(pNCEid){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE_ADMIN.PREVIEW + '?nce_record_id=' + pNCEid);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vNCEID = {
                    nce_record_id: pNCEid,
                    nce_request_id: vResponseData.data.nceapplications.nce_request_id
                };
                this._storageService.setSessionItem('NCEID', JSON.stringify(this.vNCEID));
                this.vDetailNCE = vResponseData.data.nceapplications;
                if(this.getDetailNCE().nce_request_id.slice(-2) === '-1'){
                    this._storageService.setSessionItem('extensionNCE', '0');
                } else {
                    this._storageService.setSessionItem('extensionNCE', '1');
                    this.vPlantMapExtensionID = this.vDetailNCE.plant_request_id;
                }
                resolve(vResponseData);
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }
    
    loadAppointmentAvaibility(){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE.GET_APPOINTMENT_AVAILABILITY + '?nce_record_id=' + this.vNCEID.nce_record_id);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vAppointmentAvaibility = vResponseData.data;
                resolve();
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    loadAvailableTime(pSelectedDate, pAppointmentType){
        this.vLoadingStatus = true;
        var promise = this._http.get(API_ENDPOINTS.NCE.GET_AVAILABLE_TIME + '?appointment_date=' + pSelectedDate.getFullYear() + '' 
            + ("0" + (pSelectedDate.getMonth() + 1)).slice(-2) + '' + ("0" + pSelectedDate.getDate()).slice(-2)  + '&appointment_type=' + pAppointmentType);
        let p = new Promise((resolve, reject) => {
        promise.subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this.vListTime = vResponseData.data.appointment_time;
                resolve();
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                reject();
            });
        });
        return p;
    }

    saveAppointment(pAppointmentType, pSelectedDate, pselectedTime, pContactName, pContactPhone){
        let xData = {
            nce_record_id: this.vNCEID.nce_record_id,
            appointment_type: pAppointmentType,
            appointment_date: pSelectedDate.getFullYear() + '' + ("0" + (pSelectedDate.getMonth() + 1)).slice(-2) + '' + ("0" + pSelectedDate.getDate()).slice(-2),
            appointment_time: pselectedTime,

            appointment_contactPerson: pContactName,
            appointment_contactNumber: pContactPhone
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.NCE.CREATE_APPOINTMENT, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                this._storageService.removeSessionItem('nceFiles');
                this._storageService.removeSessionItem('nceMultipleFiles');
                this._storageService.removeSessionItem('nceNewMultipleFiles');
                this.resetUploadDocumentData();
                this.vListTime = [];
                this._popupService.openLinkConfirmationPopup('Notice', 'You have successfully book date', '', true, false, 'Close', 'nce-application/view/'+this.vNCEID.nce_record_id);
            },
            (error)  => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 56508){
                    this._popupService.openGeneralConfirmationPopup('Notice', 'You have set ' + pAppointmentType + ' for this NCE. Please contact Netlink to change ' + pAppointmentType, '', false, false); //"Kowsalya: Text changed for NLT PRP portal development "
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            });
    }

    openSaveConfirmationPopup(pMessage: string, pSLMessage: string, pAppointmentType, pSelectedDate, pselectedTime, pContactName, pContactPhone){
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: pMessage,
            secondLineMessage: pSLMessage,
            buttons: {
                CANCEL: {
                    text: 'No',
                    function: () => {
                        this._popupService.closePopup();
                    }
                },
                OK: {
                    text: 'Yes',
                    function: () => {
                        this.saveAppointment(pAppointmentType, pSelectedDate, pselectedTime, pContactName, pContactPhone);
                        this._popupService.closePopup();
                    }
                }
            }}
        );
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/services/nce.service.ts